import { render, staticRenderFns } from "./HubsDashboard.vue?vue&type=template&id=2ba617a6&scoped=true&"
import script from "./HubsDashboard.vue?vue&type=script&lang=js&"
export * from "./HubsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./HubsDashboard.vue?vue&type=style&index=0&id=2ba617a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba617a6",
  null
  
)

export default component.exports